import { useState } from "react";
import { useNavigate } from "react-router-dom"
import Loader from "./Loader";

export default function Card({ title, description }) {
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate()
    const handleClick = () => {
        setLoading(true)
        const timer = setTimeout(() => {
            setLoading(false);
            navigate("register")
        }, 1000); // Set the delay time in milliseconds (e.g., 5000 for 5 seconds)

        return () => clearTimeout(timer); // Clean up the timer on component unmount

    }
    return (
        <div className="relative">
            {loading && <Loader />}
            <div className="md:mx-auto mx-6 sm:mx-8 p-3 md:p-1 sm:p-2 flex  flex-col space-y-3 rounded-lg border border-white bg-white  shadow-lg md:max-w-3xl md:flex-row md:space-x-5 md:space-y-0">
                <div className="w-full place-items-center bg-white md:w-2/4  ">
                    <img src="/images/android_poster.png" alt="tailwind logo" className="w-fit md:h-full  rounded-lg" />
                </div>
                <div className="flex w-full flex-col space-y-2 bg-white md:pr-5">
                    <h3 className="text-lg sm:text-2xl md:text-3xl font-black text-gray-800 ">{title}</h3>
                    <p className="text-xs sm:text-base text-gray-500 md:text-lg">{description}</p>
                    <div className="flex justify-center md:justify-end items-end pt-2">
                        <button className={`${loading && "flex items-center justify-center space-x-3 "} px-3 mb-3 md:mb-0  sm:text-base  rounded-md py-2 sm:py-3 w-full md:w-fit  text-white font-medium  bg-blue-950 hover:bg-blue-900  `}
                            onClick={handleClick}
                        >
                            <span>
                                Apply for the training
                            </span>
                            {loading && <div class="w-6 h-6 rounded-full animate-spin
                    border-y border-dashed border-yellow-500 border-t-transparent"></div>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}